import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

import ResponsiveImage from "components/ResponsiveImage";

export const Card = styled("div")(({ theme }) => ({
  position: "relative",
  zIndex: 0,
  backgroundColor: theme.palette.placeholder,
  minHeight: 1,
  width: "100%",
}));

export const CardImg = styled(ResponsiveImage)({
  width: "-webkit-fill-available",
  fallbacks: [{ width: "-moz-available" }],
  display: "block",
  maxWidth: "100%",
  height: "auto",
});

export const Overlay = styled("div")({
  pointerEvents: "none",
  position: "absolute",
  zIndex: 2,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(37, 45, 95, 0.7)",
  display: "flex",
  transform: "visibility 0.1s ease-in",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
});

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isClip",
})(({ theme, isClip }) => ({
  marginTop: "20px",
  "&:hover": {
    transform: "none",
  },
  [theme.breakpoints.down(500)]: {
    padding: "0 10px",
  },
  ...(isClip && {
    marginTop: 20,
    "&:hover": {
      transform: "none",
    },
    padding: "0 10px",
    height: 30,
  }),
}));
